import axiosInstance from "../api/axios";

// Fetch eSign signature requests for a given sale + document type.
// documentType is a raw enum string (e.g. BOOKING_LETTER) — NOT camelCased.
export const getSignatureRequests = (customerSalesId, documentType) =>
  axiosInstance.get(
    `/esign/signature-requests?customerSalesId=${customerSalesId}&documentType=${documentType}`
  );

// Mint the caller's Aadhaar signing URL for a signature request (opened in a new tab on web).
// `role` (optional, e.g. DEVELOPER | BUILDVIZER) disambiguates which signer a staff caller signs.
export const requestSigningUrl = (signatureRequestId, role) =>
  axiosInstance.post(
    `/esign/signature-requests/${signatureRequestId}/signing-url${role ? `?role=${role}` : ""}`
  );

// --- N-party Interior Design & Execution Agreement (staff-generated, keyed by id_lead) ---

// Preview the rendered agreement HTML (no PDF, no signing). Payload is camelCased by the client.
export const previewInteriorAgreement = (payload) =>
  axiosInstance.post(`/interior-agreement/preview`, payload);

// Render + SSL-stamp the agreement PDF and initiate the N-party Aadhaar eSign envelope.
// payload: { idLeadId, passphrase, developerRepName?, developerRepEmail?, developerRepPhone?,
//            buildvizerRepName?, buildvizerRepEmail?, buildvizerRepPhone? }
export const sendInteriorAgreement = (payload) =>
  axiosInstance.post(`/interior-agreement/send`, payload);

// Interior-agreement signature requests for the caller's Requests view.
// ZUMALE (BuildVizer) sees all; a developer sees only its own sales. Segment client-side:
// status === "COMPLETED" -> Completed, else Pending.
export const listAgreementRequests = () =>
  axiosInstance.get(`/interior-agreement/signature-requests`);

// --- Admin base-template editor (source of truth for the agreement HTML) ---

// GET the editable global base-template HTML for a notification type (ZUMALE only).
export const getBaseTemplate = (notificationType) =>
  axiosInstance.get(`/notification/base-template/${notificationType}`);

// PUT (overwrite) the base-template HTML. Body is camelCased -> { html }.
export const updateBaseTemplate = (notificationType, html) =>
  axiosInstance.put(`/notification/base-template/${notificationType}`, { html });
